import React from 'react';
import {NavLink} from 'react-router-dom';
import {LogoIcon} from 'icons';

import './header.scss';

const Header = () => (
  <div className="header">
    <div className="logo">
      <LogoIcon />
    </div>

    <div className="right">
      <nav>
        <NavLink to="/signup" activeClassName="active-menu-item">
          Sign Up
        </NavLink>
        <NavLink to="/signin" activeClassName="active-menu-item">
          Login
        </NavLink>
      </nav>
    </div>
  </div>
);

export default Header;
